import { UseCase } from '../../base/UserCase';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { CartRepository } from 'src/app/core/repositories/cart/CartRepository';
import {
    Cart,
    CartResponseDTO,
} from 'src/app/data/dto/CartDTO';

@Injectable({
    providedIn: 'root'
})

export class GetMyCartUseCase implements UseCase<Cart, CartResponseDTO> {
    constructor(
        private cartRepository: CartRepository,
    ) { }

    execute(request: Cart): Observable<CartResponseDTO> {
        return this.cartRepository.getMyCart(request);
    }
}
